/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import PopClassPlan from './_PopClassPlan';
function ShortReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const tab = [
    {title: '전체', value: 0},
    {title: '일반', value: 1},
    {title: '긴급', value: 2},
  ];
  const [modalClassPlan, setModalClassPlan] = useState(false);
  return (
    <main className="com_container p_hotline">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_6">교무핫라인</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">교무 핫라인 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01"/>
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01"/>
                  <button className="com_btn gray s">조회</button>
                </div>
                <article className="search divider">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo_1" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo_1" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo_1" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학 </label>
                  <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo_1" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo_1" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="11.5%" />
                <col width="9.6%" />
                <col/>
                <col width="11.5%" span={3} />
              </colgroup>
              <thead>
                <tr>
                  <th>등록일
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>비고</th>
                  <th>제목</th>
                  <th>등록부서</th>
                  <th>등록자</th>
                  <th>조회</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2023. 05, 06</td>
                  <td>일반</td>
                  <td className='td_left'>인사팀 회의록 입니다 [1]</td>
                  <td>인사총무</td>
                  <td>홍길동103</td>
                  <td>35</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 , 13, 14 , 15].map(() => {
                  return (
                    <tr>
                      <td>2023. 05, 06</td>
                      <td>일반</td>
                      <td className='td_left'>인사팀 회의록 입니다 [1]</td>
                      <td>인사총무</td>
                      <td>홍길동103</td>
                      <td>35</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20  11 : 30</p>
              <div className="count">
                조회 321
              </div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <select className="select">
                  <option value="선택">과목 선택</option>
                </select>
                <div className="com_radio_wrap">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">일반</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">긴급</label>
                </div>
                <div className="com_btn_wrap">
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder="제목 입력" />
              </div>
              <div className="editor light_gray">인사총무팀에서 공유 드립니다.<br/><br/>

                물품 청구서 양식입니다.<br/>
                감사합니다
              </div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
            <hr className='com_divider'/>
            <div className="com_btn_wrap center">
              <div className="com_btn orange s wl">등록</div>
            </div>
            <div className="com_comment_wrap type_board">
              <ul className="comment_list">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <li className="item" key={idx}>
                      <div className="info">
                        <p className="name">홍길동103</p>
                        <p className="date dot">2025, 05, 20 11 : 30</p>
                        <div className="com_btn_wrap">
                          <button className="btn_edit"></button>
                          <button className="btn_delete"></button>
                        </div>
                      </div>
                      <p className="txt">축하드려요~!</p>
                    </li>
                  );
                })}
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="내용 입력" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopClassPlan open={modalClassPlan} close={() => setModalClassPlan(false)} />
    </main>
  );
}

export default ShortReport;
